export default "__VITE_PUBLIC_ASSET__52184ed7__"